import Dialog from "~/ui/dialog";
import { node } from "~/util/dom";
import { store } from "~/state/store";
import { setCoordinates } from "~/state/map/state";

interface ILoadingPagePromoOptions {
	url: string;
	query: string;
	img: string;
	trans: {
		"firmPromo.title": string;
		"firmPromo.description": string;
		"firmPromo.reviewBtn": string;
	};
}

export const PROMO_BREWERY = 1;
export const PROMO_RESTAURANT = 2;

const SETTINGS = {
	[PROMO_RESTAURANT]: {
		url: "restaurace",
		query: "restaurace",
		img: "realna-recenze_restaurace",
		trans: {
			"firmPromo.title": "Kde mají guláš jako od maminky?",
			"firmPromo.description": "Napište restauracím své hodnocení. A můžete přidat i aktuální fotky nabídky. Pomůžete tak ostatním dobře vybrat a příště zase inspirují oni vás.",
			"firmPromo.reviewBtn": "Hodnotit restaurace",
		},
	},
	[PROMO_BREWERY]: {
		url: "pivovary",
		query: "pivovary",
		img: "realna-recenze_pivovar",
		trans: {
			"firmPromo.title": "Kde mají pivo jako křen?",
			"firmPromo.description": "Napište pivovarům své hodnocení. Můžete přidat i aktuální fotky z čepu. Pomůžete tak ostatním dobře vybrat a příště zase inspirují oni vás.",
			"firmPromo.reviewBtn": "Hodnotit pivovary",
		},
	},
};

const SEARCH_ZOOM = 12;

function log(name = "", data: any) {
	Mapy.getComponent("logger").log(name, {
		name: "Pomáháme hodnocení",
		...data,
	});
}

export default class LandingPagePromo {
	_active: boolean;

	_url: string;

	_dialog: Dialog;

	_options: ILoadingPagePromoOptions;

	constructor(mode: number) {
		this._options = SETTINGS[mode];
		this._dialog = null;
		this._active = false;
		this._url = "";
	}

	static destroy() {
	}

	isActive() {
		return this._active;
	}

	activate() {
		if (this.isActive()) {
			return this;
		}

		this._url = location.pathname + location.search;

		if (!Mapy.getComponent("history").isFromHistory()) {
			history.pushState(null, "", `/${this._options.url}`);
		}

		this._active = true;
		this._open();

		return this;
	}

	deactivate() {
		if (!this.isActive()) {
			return this;
		}

		this._active = false;
		this._close();

		if (this._url.indexOf(this._options.url) === -1) {
			history.replaceState(null, "", this._url);
		} else {
			Mapy.getComponent("history").save(true);
		}

		return this;
	}

	setState() {
		if (location.pathname.indexOf(this._options.url) === -1) {
			this.deactivate();
		} else {
			this.activate();
		}
	}

	static getState() {
		return {};
	}

	_open() {
		this._dialog = new Dialog({
			className: "firm-promo",
			title: this._options.trans["firmPromo.title"],
			onClose: () => {
				// analytika
				log("promo", {
					type: "popup_reviews_close",
				});

				this.deactivate();
			},
		});
		this._dialog.addBtn({
			title: this._options.trans["firmPromo.reviewBtn"],
			logIgnore: true,
			type: "ok",
			cb: () => {
				// analytika
				log("promo", {
					type: "popup_reviews_evaluate_firms",
				});

				const geoCoords = Mapy.getGEOLocationCoords();
				const { longitude, latitude } = store.getState().map;

				store.dispatch(setCoordinates({
					longitude: geoCoords ? geoCoords.x : longitude,
					latitude: geoCoords ? geoCoords.y : latitude,
					zoom: SEARCH_ZOOM,
					animate: false,
				}));
				this.deactivate();
				Mapy.getComponent("search").activate().setState({
					q: this._options.query,
					cat: 1,
					sf: "review:from40",
					searchOrigin: "promo",
				});
				Mapy.getComponent("history").save();
			},
		});
		const img = node("img", { src: `/img/realna-recenze/${this._options.img}.png`, srcset: `/img/realna-recenze/${this._options.img}@2x.png 2x` });
		const description = node("p", { className: "description", textContent: this._options.trans["firmPromo.description"] });

		this._dialog.dom.content.appendChild(description);
		this._dialog.dom.content.appendChild(img);
		this._dialog.open();
		document.body.style.overflow = "hidden";

		// analytika
		log("promo_impress", {
			type: "popup_reviews",
		});
	}

	_close() {
		if (!this._dialog) {
			return;
		}
		document.body.style.overflow = "";
		this._dialog.close();
		this._dialog = null;
	}
}
